// extracted by mini-css-extract-plugin
export default {"item":"PostItem_item__D+DXM"};